import { combineReducers } from '@fullstory/redux-util/utils';
import { settingsElementAttributes } from './elemattributes';

type SearchSettingsState = {
  settingsElementAttributes: ReturnType<typeof settingsElementAttributes>;
};

export const searchSettings = combineReducers<SearchSettingsState>({
  settingsElementAttributes,
});
